import Script from "next/script";
import { isProduction } from "../utils/environment";

// These values are constants for all services
const GTM_PRODUCTION_ID = "GTM-K7GFJTV";
const GTM_DEV_ID = "GTM-PD8S23G";

function GoogleTagManagerScript() {
  const googleTagManagerId = isProduction() ? GTM_PRODUCTION_ID : GTM_DEV_ID;

  return (
    <>
      <Script id="reporting-ga-init" strategy="afterInteractive">
        {/* eslint-disable-next-line react/jsx-no-literals -- inline third-party script body, not user-facing copy */}
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${googleTagManagerId}');
      `}
      </Script>

      <Script id="reporting-gtm" strategy="afterInteractive">
        {/* eslint-disable-next-line react/jsx-no-literals -- inline third-party script body, not user-facing copy */}
        {`
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${googleTagManagerId}');
        `}
      </Script>
    </>
  );
}

export default GoogleTagManagerScript;
